import { API } from "./api";

const BYDAY = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];
const compact = (date, hhmm) => `${date.replace(/-/g, "")}T${hhmm.replace(":", "")}00`;
const weekdayOf = (date) => (new Date(`${date}T12:00:00`).getDay() + 6) % 7;

export const icsUrl = (session, date, mode) =>
  `${API}/courses/${session.course_id}/calendar.ics?start=${encodeURIComponent(session.start)}&date=${date}&mode=${mode}`;

export const googleUrl = (session, date, mode, season) => {
  const title = `${session.course_name} · ${session.level || ""}${session.age ? ` (${session.age})` : ""}`.trim();
  const location = [season?.venue_name, season?.address, season?.city].filter(Boolean).join(", ");
  const details = `Cours ${session.course_name}${session.room ? ` — ${session.room}` : ""}. FEDEVO 2.0 · ${season?.label || ""}\n${window.location.origin}/cours`;
  const p = new URLSearchParams({ action: "TEMPLATE", text: title, dates: `${compact(date, session.start)}/${compact(date, session.end)}`, ctz: "Europe/Paris", details, location });
  if (mode === "season" && season?.end_date) {
    p.set("recur", `RRULE:FREQ=WEEKLY;BYDAY=${BYDAY[weekdayOf(date)]};UNTIL=${season.end_date.replace(/-/g, "")}`);
  }
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};
